var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"checkbox",attrs:{"role":"checkbox"},on:{"click":function($event){$event.preventDefault();return _vm.check.apply(null, arguments)}}},[_c('span',{class:[
      'checkbox-input',
      _vm.disabled ? 'is_disabled' : '',
      _vm.checkControl ? 'is_checked' : '',
    ],attrs:{"aria-checked":"mixed"}},[_c('span',{staticClass:"checkbox-input-inner"}),_c('input',{staticClass:"checkbox-input-original",attrs:{"disabled":_vm.disabled,"type":"checkbox","aria-hidden":"true"}})]),_c('span',{staticClass:"checkbox-label",style:(_vm.isActive ? 'font-weight: bold' : '')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }